var _rect, _rect2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDuplicate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 39.5,
    height: 39.5,
    rx: 5.75,
    fill: "#F1FBFB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 39.5,
    height: 39.5,
    rx: 5.75,
    stroke: "#ABECEB",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2998 22.6998C17.2998 20.1543 17.2998 18.8815 18.0906 18.0906C18.8815 17.2998 20.1543 17.2998 22.6998 17.2998H23.5998C26.1454 17.2998 27.4182 17.2998 28.209 18.0906C28.9998 18.8815 28.9998 20.1543 28.9998 22.6998V23.5998C28.9998 26.1454 28.9998 27.4182 28.209 28.209C27.4182 28.9998 26.1454 28.9998 23.5998 28.9998H22.6998C20.1543 28.9998 18.8815 28.9998 18.0906 28.209C17.2998 27.4182 17.2998 26.1454 17.2998 23.5998V22.6998Z",
    stroke: "#007E7F",
    strokeWidth: 1.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 17.3C24.4978 14.6386 24.4576 13.2601 23.6828 12.3162C23.5333 12.1339 23.3661 11.9668 23.1839 11.8172C22.1881 11 20.7088 11 17.75 11C14.7913 11 13.3119 11 12.3162 11.8172C12.1339 11.9668 11.9668 12.1339 11.8172 12.3162C11 13.3119 11 14.7913 11 17.75C11 20.7088 11 22.1881 11.8172 23.1839C11.9668 23.3661 12.1339 23.5333 12.3162 23.6828C13.2601 24.4576 14.6386 24.4978 17.3 24.5",
    stroke: "#007E7F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate);
export default __webpack_public_path__ + "static/media/duplicate.fa4672d411f9faffbe9213f66334f615.svg";
export { ForwardRef as ReactComponent };